import { Controller } from "@hotwired/stimulus"

/**
 * Replaces a scheduled post with a new Content via the selection pattern.
 * Listens for selection-receiver:changed, then submits a POST to
 * /posts/:postId/replace?content_id=:id.
 *
 * The server responds with a turbo_stream that replaces the calendar cards
 * and resets the post modal frame.
 *
 * Values:
 *   postId – the Post to replace
 *
 * Targets:
 *   form – a hidden <form> used to submit the replace request
 *   contentField – the hidden input that receives the selected content_id
 */
export default class extends Controller {
  static values = { postId: Number }
  static targets = ["form", "contentField"]

  replacePost(event) {
    const { id } = event.detail;
    if (!id || !this.hasFormTarget) return;

    this.formTarget.action = `/posts/${this.postIdValue}/replace`;
    this.contentFieldTarget.value = id;
    this.formTarget.requestSubmit();
  }
}
